/**
 * ProLayout 静态默认项（navTheme、layout、title、logo…）；运行时由 `getInitialState` 与本地主题存储合并。
 * 调色与布局 token 分见 `antdThemeByMode.ts`、`proLayoutThemeByMode.ts`。
 */
import type { ProLayoutProps } from '@ant-design/pro-components';

/**
 * @name 默认布局配置
 */
const Settings: ProLayoutProps & {
  pwa?: boolean;
  logo?: string;
} = {
  navTheme: 'realDark',
  layout: 'side',
  contentWidth: 'Fluid',
  /**
   * `layout: 'side'` 时 ProLayout 不会在右侧内容区渲染顶栏，「内容区顶栏」需在 `childrenRender` 里自绘（见 ContentToolbar）。
   * `fixedHeader` 对纯 side 桌面端无顶栏可固定；保留 true 与 mix/顶部布局兼容。
   */
  fixedHeader: true,
  fixSiderbar: true,
  colorWeak: false,
  title: '榴莲',
  splitMenus: false,
  siderMenuType: 'group',
  footerRender: false,
  pwa: true,
  logo: '/logo.png',
  iconfontUrl: '',
  token: {
    // 侧栏/页面容器背景：config/proLayoutThemeByMode.ts（运行时按 navTheme 合并）
    // 菜单项字号、颜色：antd `components.Menu` → config/antdThemeByMode.ts，细调见 src/global.less（侧栏菜单）
    // 文档：https://procomponents.ant.design/components/layout#通过-token-修改样式
  },
};

export default Settings;  